<template>
  <div>
    <q-page padding class="container">
      <div class="row col-12 q-mt-sm q-gutter-xs text-brand-5 text-weight-bold">
        <div>
          <q-btn
            label="Filtros"
            color="primary"
            no-caps
            icon-right="tune"
            :outline="!rightDrawerModalOpen"
            @click="rightDrawerModalOpen = true"
          />
        </div>
      </div>
      <div
        class="row col-12 q-ml-md q-mt-md text-brand-5 text-weight-bold q-mb-lg"
      >
        <div v-for="(filtro, index) in filtrosAplicados" :key="index">
          <div
            class="row col-12 q-mr-sm q-mt-md items-center justify-between card-nome-filtro"
            @click="rightDrawerModalOpen = true"
            style="cursor: pointer"
          >
            <span>{{ filtro }}</span>
          </div>
        </div>
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerModalOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center justify-between">
              <div class="row">
                <q-icon
                  style="cursor: pointer"
                  name="close"
                  class="q-mr-md"
                  size="22px"
                  @click="rightDrawerModalOpen = false"
                />
                <span style="font-size: 16px">
                  <span>
                    <span>Filtros</span>
                  </span>
                </span>
              </div>
              <div>
                <q-btn
                  icon="delete"
                  color="red"
                  label="Limpar"
                  no-caps
                  dense
                  @click="limparCampos()"
                />
              </div>
            </div>
          </div>
          <q-scroll-area class="teste" style="width: 100%; height: 92%">
            <div class="column col-12 no-wrap">
              <div class="q-px-md text-weight-bold">
                <div class="col-md-12">
                  <SelecaoClientes
                    @enviarCliente="receberClienteFiltro"
                    :model="filtros.cliente"
                  />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <SelecaoUnidades
                    @enviarUnidade="receberUnidadeFiltro"
                    :clienteId="filtros.cliente.clienteId"
                    :resetar="resetarUnidadeFiltro"
                    :model="filtros.unidade"
                  />
                </div>
                <div class="col-md-12">
                  <div class="col-md-12">
                    <SelecaoSistemas
                      @enviarSistema="receberSistemaFiltro"
                      :model="filtros.sistema"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <SelecaoVersao
                    @enviarVersao="receberVersaoFiltro"
                    :reset="resetVersao"
                    :sistemaUuid="filtros.sistema?.uuid"
                    :model="filtros.versao"
                  />
                </div>
                <div class="col-md-12">
                  <div class="texto-titulo-input q-mb-xs">Tipo Integração</div>
                  <q-select
                    v-model="filtros.tipoIntegracao"
                    :options="options.optionsTipoIntegracao"
                    dense
                    outlined
                    class="input"
                  />
                </div>
                <div class="col-md-12">
                  <div class="texto-titulo-input q-mb-xs">
                    Método Integração
                  </div>
                  <q-select
                    v-model="filtros.metodoIntegracao"
                    :options="options.optionsMetodo"
                    dense
                    outlined
                    class="input"
                  />
                </div>
                <div class="col-md-12">
                  <div class="texto-titulo-input q-mb-xs">Protocolo</div>
                  <q-select
                    v-model="filtros.protocolo"
                    :options="options.optionsProtocolo"
                    dense
                    outlined
                    class="input"
                  />
                </div>
                <div class="row col-12 q-mt-xs q-gutter-x-sm">
                  <div class="col">
                    <div class="texto-titulo-input q-mb-xs">Data Envio</div>
                    <q-input
                      v-model="filtros.dataEnvio"
                      dense
                      outlined
                      class="input"
                      placeholder="DD/MM/AAAA"
                      mask="##/##/####"
                    >
                      <template v-slot:append>
                        <q-icon name="event" class="cursor-pointer">
                          <q-popup-proxy
                            cover
                            transition-show="scale"
                            transition-hide="scale"
                          >
                            <q-date
                              v-model="filtros.dataEnvio"
                              :locale="myLocale"
                              mask="DD/MM/YYYY"
                            >
                              <div class="row items-center justify-end">
                                <q-btn
                                  v-close-popup
                                  label="Fechar"
                                  color="primary"
                                  flat
                                />
                              </div>
                            </q-date>
                          </q-popup-proxy>
                        </q-icon>
                      </template>
                    </q-input>
                  </div>
                </div>
              </div>
              <div class="q-px-md q-mt-md q-pb-md">
                <q-btn
                  dense
                  label="Filtrar"
                  no-caps
                  icon="filter_alt"
                  color="primary"
                  @click="
                    listarTotalRequisicoesIntegradas(),
                      listarSistemasIntegrados()
                  "
                />
              </div>
            </div>
          </q-scroll-area>
        </q-card>
      </Transition>
      <div class="row">
        <div class="col">
          <div>
            <PieChart
              :titulo="'Clientes por Sistema'"
              :labels="dadosGraficoClientesSistema.labels"
              :datasets="dadosGraficoClientesSistema.datasets"
            />
          </div>
        </div>
        <div class="col">
          <PieChart
            :titulo="'Tipo Integração'"
            :labels="dadosGraficoTipoIntegracao.labels"
            :datasets="dadosGraficoTipoIntegracao.datasets"
          />
        </div>
        <div class="col">
          <BarChart
            :titulo="'Tipo de Erro'"
            :labels="dadosGraficoBarChart.labels"
            :datasets="dadosGraficoBarChart.datasets"
          />
        </div>
      </div>
      <div class="row col-12 q-mt-md q-gutter-sm">
        <div
          style="font-size: 18px"
          class="row col-12 text-brand-5 text-weight-bold q-ml-md q-my-lg"
        >
          Estatísticas Integrações
        </div>
        <div class="col">
          <q-card class="text-white text-weight-bold card-1">
            <q-card-section>
              <span class="row col-12 q-mb-md">{{ highlights.total }}</span>
              <div class="row col-12 justify-between items-center">
                <span>Total Enviado</span>
                <q-icon name="bar_chart" size="40px" />
              </div>
            </q-card-section>

            <q-separator color="grey-1" />

            <q-card-section>
              <div class="row col-12 items-center">
                <q-icon class="q-mr-sm" name="alarm" size="23px" />
                <span
                  >Atualizado:
                  {{ data?.split(" ")[0].split("-").reverse().join("/") }}</span
                >
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col">
          <q-card class="text-white text-weight-bold card-2">
            <q-card-section>
              <span class="row col-12 q-mb-md"
                >{{ highlights.enviadoExito }} /
                {{
                  parseFloat(highlights.porcentagemSucesso).toFixed(2)
                }}%</span
              >
              <div class="row col-12 justify-between items-center">
                <span>Enviado c/ Êxito</span>
                <q-icon name="bar_chart" size="40px" />
              </div>
            </q-card-section>

            <q-separator color="grey-1" />

            <q-card-section>
              <div class="row col-12 items-center">
                <q-icon class="q-mr-sm" name="alarm" size="23px" />
                <span
                  >Atualizado:
                  {{ data?.split(" ")[0].split("-").reverse().join("/") }}</span
                >
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col">
          <q-card class="text-white text-weight-bold card-4">
            <q-card-section>
              <span class="row col-12 q-mb-md"
                >{{ highlights.pendente }} /
                {{
                  parseFloat(highlights.porcentagemPendente).toFixed(2)
                }}%</span
              >
              <div class="row col-12 justify-between items-center">
                <span>Pendente</span>
                <q-icon name="bar_chart" size="40px" />
              </div>
            </q-card-section>

            <q-separator color="grey-1" />

            <q-card-section>
              <div class="row col-12 items-center">
                <q-icon class="q-mr-sm" name="alarm" size="23px" />
                <span
                  >Atualizado:
                  {{ data?.split(" ")[0].split("-").reverse().join("/") }}</span
                >
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col">
          <q-card class="text-white text-weight-bold card-3">
            <q-card-section>
              <span class="row col-12 q-mb-md"
                >{{ highlights.enviadoErro }} /
                {{ parseFloat(highlights.porcentagemErro).toFixed(2) }}%</span
              >
              <div class="row col-12 justify-between items-center">
                <span>Enviado c/ Erro</span>
                <q-icon name="bar_chart" size="40px" />
              </div>
            </q-card-section>

            <q-separator color="grey-1" />

            <q-card-section>
              <div class="row col-12 items-center">
                <q-icon class="q-mr-sm" name="alarm" size="23px" />
                <span
                  >Atualizado:
                  {{ data?.split(" ")[0].split("-").reverse().join("/") }}</span
                >
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
      <div class="row col-12 q-mt-md">
        <div
          style="font-size: 18px"
          class="row col-12 text-brand-5 text-weight-bold q-ml-md q-my-lg"
        >
          Lista de Clientes Integrações
        </div>
        <div class="col">
          <q-table
            flat
            table-header-class="bg-accent text-weight-bold"
            :columns="columns"
            :rows="listaSistemasIntegracoes"
            color="primary"
            class="tabela-tamanho-fixo"
            dense
            :loading="loading"
          >
            <template v-slot:body-cell-cliente="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.clienteId
              }}</q-td>
            </template>
            <template v-slot:body-cell-unidade="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.unidade
              }}</q-td>
            </template>
            <template v-slot:body-cell-sistema="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.sistema
              }}</q-td>
            </template>
            <template v-slot:body-cell-tipoIntegracao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.tipo
              }}</q-td>
            </template>
            <template v-slot:body-cell-versao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.versao
              }}</q-td>
            </template>
            <template v-slot:body-cell-protocolo="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.protocolo
              }}</q-td>
            </template>
            <template v-slot:body-cell-metodo="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.metodo
              }}</q-td>
            </template>
            <template v-slot:body-cell-dataAtivacao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.dataAtivacao
                  ?.split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</q-td>
            </template>
            <template v-slot:body-cell-status="props">
              <q-td :props="props">
                <div
                  :style="
                    props.row.dataDesativacao === null
                      ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                      : 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                  "
                  class="row items-center text-brand-5 text-weight-bold"
                >
                  <div
                    v-if="props.row.dataDesativacao === null"
                    class="elipse q-mr-xs bg-positive"
                  ></div>
                  <div v-if="props.row.dataDesativacao == null">
                    <span v-if="props.row.dataDesativacao === null">Ativo</span>
                    <span v-else
                      >Inativo<q-tooltip>{{
                        props.row.dataDesativacao
                      }}</q-tooltip></span
                    >
                  </div>
                  <div
                    v-else
                    class="elipse q-mr-xs"
                    style="background: red"
                  ></div>
                </div>
              </q-td>
            </template>
          </q-table>
        </div>
      </div>
    </q-page>
    <div
      v-if="rightDrawerModalOpen"
      @click="rightDrawerModalOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

import PieChart from "../components/PieChart.vue";
import BarChart from "../components/BarChart.vue";
import SelecaoClientes from "../components/SelecaoClientes.vue";
import SelecaoSistemas from "../components/SelecaoSistemas.vue";
import SelecaoUnidades from "../components/SelecaoUnidade.vue";
import SelecaoVersao from "../components/SelecaoVersoes.vue";

const store = useStore();

const columns = [
  {
    name: "cliente",
    label: "Cliente",
    align: "left",
    field: "clienteId",
  },
  {
    name: "unidade",
    label: "Unidade",
    align: "left",
  },
  {
    name: "sistema",
    label: "Sistema",
    align: "left",
  },
  {
    name: "tipoIntegracao",
    label: "Tipo Int.",
    align: "left",
  },
  {
    name: "versao",
    label: "Versão",
    align: "left",
  },
  {
    name: "protocolo",
    label: "Protocolo",
    align: "left",
  },
  {
    name: "metodo",
    label: "Método",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "dataAtivacao",
    label: "Data Ativação",
    align: "left",
  },
];
let rightDrawerModalOpen = ref(false);
const filtros = ref({
  cliente: { clienteId: "", ativo: "" },
  sistema: { uuid: "", sistema: "" },
  unidade: { clienteId: "", unidadeId: "", unidade: "" },
  dataEnvio: "",
  versao: "",
  tipoIntegracao: "",
  metodoIntegracao: "",
  protocolo: "",
});
let resetarUnidadeFiltro = ref(0);
const dadosGraficoBarChart = ref({
  labels: [""],
  datasets: [
    {
      label: "Erro Interno",
      data: [],
      backgroundColor: ["#F9D949"],
    },
    {
      label: "Erro Externo",
      data: [],
      backgroundColor: ["#FF0303"],
    },
  ],
});

const dadosGraficoClientesSistema = ref({
  labels: [],
  datasets: [
    {
      label: "",
      data: [],
      backgroundColor: [],
    },
  ],
});

const dadosGraficoTipoIntegracao = ref({
  labels: ["Consumo", "Pessoa"],
  datasets: [
    {
      label: "",
      data: [],
      backgroundColor: ["#213864", "#6AD9B1"],
    },
  ],
});
const filtrosAplicados = ref([]);

const highlights = ref({
  total: "",
  enviadoExito: "",
  enviadoErro: "",
  porcentagemErro: "",
  porcentagemSucesso: "",
  porcentagemPendente: "",
});

const options = ref({
  optionsTipoIntegracao: [
    { label: "Consumo", value: "consumo" },
    { label: "Pessoa", value: "pessoa" },
  ],
  optionsVersao: [],
  optionsTipo: [
    { label: "Consumo", value: "consumo" },
    { label: "Pessoa", value: "pessoa" },
  ],
  optionsMetodo: [
    { label: "Envio", value: "envio" },
    { label: "Consumo", value: "consumo" },
  ],
  optionsProtocolo: [
    { label: "REST", value: "rest" },
    { label: "SOAP", value: "soap" },
  ],
});
const listaSistemasIntegracoes = ref([]);
let loading = ref(false);
let resetVersao = ref(0);

const data = ref("");

const listarTotalRequisicoesIntegradas = async () => {
  try {
    dadosGraficoBarChart.value.datasets[0].data = [];
    dadosGraficoBarChart.value.datasets[1].data = [];
    const response = await store.dispatch(
      "office/listarTotalRequisicoesIntegradas",
      {
        clienteId: filtros.value.cliente.clienteId || null,
        unidadeId: filtros.value.unidade.unidadeId || null,
        dataEnvio:
          filtros.value.dataEnvio?.split("/").reverse().join("-") || null,
      }
    );
    let sucesso;
    let erro;
    let pendente;
    resetHighlights();
    if (filtros.value.dataEnvio != "") {
      data.value = filtros.value.dataEnvio;
    } else {
      data.value = "";
    }
    if (response.data.resultado.dados.length > 0) {
      let sucessoTotal = response.data.resultado.dados.filter((element) =>
        element.tipo.includes("sucesso")
      );
      sucesso = sucessoTotal[0].quantidade;
      let erroTotal = response.data.resultado.dados.filter(
        (element) =>
          element.tipo.includes("erro-interno") ||
          element.tipo.includes("erro-externo")
      );
      let erroInternoTotal = response.data.resultado.dados.filter((element) =>
        element.tipo.includes("erro-interno")
      );
      let erroExternoTotal = response.data.resultado.dados.filter((element) =>
        element.tipo.includes("erro-externo")
      );
      erro = erroTotal.reduce(
        (acumulador, valorAtual) => acumulador + valorAtual.quantidade,
        0
      );
      let pendenteTotal = response.data.resultado.dados.filter((element) =>
        element.tipo.includes("pendente")
      );
      pendente = pendenteTotal[0]?.quantidade || 0;
      dadosGraficoBarChart.value.datasets[0].data.push(
        erroExternoTotal[0].quantidade
      );
      dadosGraficoBarChart.value.datasets[1].data.push(
        erroInternoTotal[0].quantidade
      );
      let total = sucesso + erro + pendente;
      highlights.value = {
        total: sucesso + erro + pendente,
        enviadoExito: sucesso || 0,
        enviadoErro: erro || 0,
        pendente: pendente,
        porcentagemErro: (erro / total) * 100,
        porcentagemSucesso: (sucesso / total) * 100,
        porcentagemPendente: (pendente / total) * 100,
      };
      rightDrawerModalOpen.value = false;
    }
    rightDrawerModalOpen.value = false;
  } catch (error) {
    console.log(error);
  }
};

const listarClientesPorSistema = async () => {
  try {
    dadosGraficoClientesSistema.value.labels = [];
    dadosGraficoClientesSistema.value.datasets[0].data = [];
    const response = await store.dispatch("office/listarClientesPorSistema");
    let totalClientesSistema = response.data.resultado.dados.reduce(
      (acumulador, valorAtual) => acumulador + valorAtual.qtdCliente,
      0
    );
    response.data.resultado.dados.forEach((element) => {
      dadosGraficoClientesSistema.value.labels.push(
        `${element.sistema}: ${element.qtdCliente}`
      );
      dadosGraficoClientesSistema.value.datasets[0].data.push(
        parseFloat((element.qtdCliente / totalClientesSistema) * 100).toFixed(1)
      );
      dadosGraficoClientesSistema.value.datasets[0].backgroundColor.push(
        generateColor()
      );
    });
  } catch (error) {
    console.log(error);
  }
};

const listarSistemasIntegrados = async () => {
  try {
    loading.value = true;
    const response = await store.dispatch("office/listarSistemasIntegrados", {
      clienteId: filtros.value.cliente.clienteId || null,
      unidadeId: filtros.value.unidade.unidadeId || null,
      sistemaUuid: filtros.value.sistema?.uuid || null,
      versao: filtros.value.versao?.versao || null,
      tipo: filtros.value.tipo?.value || null,
      metodo: filtros.value.metodo?.value || null,
      protocolo: filtros.value.protocolo?.value || null,
      dataAtivacao:
        filtros.value.dataEnvio?.split("/").reverse().join("-") || null,
    });
    listaSistemasIntegracoes.value = response.data.resultado.dados;
    loading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const listarIntegracoesPorTipo = async () => {
  try {
    let consumo;
    let pessoa;
    const response = await store.dispatch("office/listarIntegracoesPorTipo");
    dadosGraficoTipoIntegracao.value.labels = [];
    dadosGraficoTipoIntegracao.value.datasets[0].data = [];
    if (response.data.resultado.dados) {
      let total = response.data.resultado.dados.reduce(
        (acumulador, valorAtual) => acumulador + valorAtual.quantidade,
        0
      );
      let consumoTotal = response.data.resultado.dados.filter((element) =>
        element.tipo.includes("Consumo")
      );
      let pessoaTotal = response.data.resultado.dados.filter((element) =>
        element.tipo.includes("pessoa")
      );
      response.data.resultado.dados.forEach((element) => {
        dadosGraficoTipoIntegracao.value.labels.push(
          `${element.tipo} ${element.quantidade}`
        );
      });
      consumo = consumoTotal[0]?.quantidade || 0;
      pessoa = pessoaTotal[0]?.quantidade || 0;
      dadosGraficoTipoIntegracao.value.datasets[0].data.push(
        parseFloat((consumo / total) * 100).toFixed(1)
      );
      dadosGraficoTipoIntegracao.value.datasets[0].data.push(
        parseFloat((pessoa / total) * 100).toFixed(1)
      );
    }
  } catch (error) {
    console.log(error);
  }
};

const receberClienteFiltro = (value) => {
  aplicarFiltros(undefined, filtros.value.unidade?.unidade, "Unidade");
  if (value == null) {
    resetarUnidadeFiltro.value++;
    filtros.value.cliente = "";
    filtros.value.unidade = "";
    aplicarFiltros(
      value?.clienteId,
      filtros.value.cliente?.clienteId,
      "Cliente"
    );
    return;
  }
  if (value.clienteId == filtros.value.cliente.clienteId) {
    return;
  }
  aplicarFiltros(value?.clienteId, filtros.value.cliente?.clienteId, "Cliente");
  resetarUnidadeFiltro.value++;
  filtros.value.cliente = value;
};

const receberSistemaFiltro = (value) => {
  aplicarFiltros(undefined, filtros.value.versao?.versao, "Versão");
  if (value == null || value == "") {
    resetVersao.value++;
    aplicarFiltros(value?.sistema, filtros.value.sistema?.sistema, "Sistema");
    return;
  }
  resetVersao.value++;
  aplicarFiltros(value?.sistema, filtros.value.sistema?.sistema, "Sistema");
  filtros.value.sistema = value;
};

const receberVersaoFiltro = (value) => {
  aplicarFiltros(value?.versao, filtros.value.versao?.versao, "Versão");
  filtros.value.versao = value;
};

const receberUnidadeFiltro = (value) => {
  if (value == null || value == "") {
    resetarUnidadeFiltro.value++;
    filtros.value.unidade = "";
    aplicarFiltros(value?.unidade, filtros.value.unidade?.unidade, "Unidade");
    return;
  }
  aplicarFiltros(value?.unidade, filtros.value.unidade?.unidade, "Unidade");
  filtros.value.unidade = value;
};

function generateColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";

  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }

  return color;
}

const myLocale = {
  days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
  daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
  months:
    "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
      "_"
    ),
  monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
  firstDayOfWeek: 1,
};

const resetHighlights = () => {
  highlights.value = {
    total: 0,
    enviadoExito: 0,
    enviadoErro: 0,
    pendente: 0,
    porcentagemErro: 0,
    porcentagemSucesso: 0,
    porcentagemPendente: 0,
  };
};
const limparCampos = () => {
  resetarUnidadeFiltro.value++;
  resetVersao.value++;
  resetarUnidadeFiltro.value++;
  filtros.value = {
    cliente: { clienteId: "", ativo: "" },
    sistema: { uuid: "", sistema: "" },
    unidade: { clienteId: "", unidadeId: "", unidade: "" },
    dataEnvio: "",
    versao: "",
    metodo: "",
    protocolo: "",
  };
  filtrosAplicados.value = [];
};

const aplicarFiltros = (valorNovo, valorAtual, tipoFiltro) => {
  let index = filtrosAplicados.value.indexOf(`${tipoFiltro}: ${valorAtual}`);
  if (valorNovo == undefined && index == -1) {
    return;
  }
  if (valorNovo == undefined || valorNovo == "") {
    filtrosAplicados.value.splice(index, 1);
    return;
  }
  if (index == -1) {
    filtrosAplicados.value.push(`${tipoFiltro}: ${valorNovo}`);
  } else {
    filtrosAplicados.value.splice(index, 1, `${tipoFiltro}: ${valorNovo}`);
  }
};

watch(
  () => filtros.value.metodoIntegracao?.value,
  (novo, antigo) => {
    aplicarFiltros(novo, antigo, "Método Integração");
  }
);

watch(
  () => filtros.value.tipoIntegracao?.value,
  (novo, antigo) => {
    aplicarFiltros(novo, antigo, "Tipo Integração");
  }
);

watch(
  () => filtros.value.protocolo?.value,
  (novo, antigo) => {
    aplicarFiltros(novo, antigo, "Protocolo");
  }
);

watch(
  () => filtros.value.dataEnvio,
  (novo, antigo) => {
    aplicarFiltros(novo, antigo, "Data Envio");
  }
);

onMounted(() => {
  listarTotalRequisicoesIntegradas();
  listarClientesPorSistema();
  listarSistemasIntegrados();
  listarIntegracoesPorTipo();
});
</script>

<style scoped>
.elipse {
  width: 15px;
  height: 15px;
  border-radius: 100%;
}
.card-1 {
  background-image: radial-gradient(
    circle 975px at 2.6% 48.3%,
    rgba(0, 8, 120, 1) 0%,
    rgba(95, 184, 224, 1) 99.7%
  );
}
.card-4 {
  background-image: radial-gradient(
    circle farthest-corner at 10% 20%,
    rgba(249, 232, 51, 1) 0%,
    rgba(250, 196, 59, 1) 100.2%
  );
}
.card-3 {
  background-image: radial-gradient(
    circle farthest-corner at 17.1% 22.8%,
    rgba(226, 24, 24, 1) 0%,
    rgba(160, 6, 6, 1) 90%
  );
}
.card-2 {
  background-image: linear-gradient(135deg, #70f570 10%, #49c628 100%);
}
.container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.card-nome-filtro {
  background-color: #dfebf2;
  padding: 5px 10px;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.teste {
  z-index: 2;
  overflow: hidden;
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
</style>
